import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MissingHcpIcon } from '@/assets/icons/MissingHcpIcon';
import { DcrType, EntityType } from '@/core/graphql/generated/types';
import { mergeSx } from '@/utils/mergeSx';

import { DataChangeRequest } from '../DcrModal/DataChangeRequest';

import { dcrSearchCtaStyles as sx } from './DcrSearchCta.styles';

type Props = {
	entityType: EntityType;
	customSx?: {
		header?: SxProps<Theme>;
	};
};

export const DcrSearchCta = ({ entityType, customSx }: Props) => {
	const { t } = useTranslation();
	const [isDcrOpen, setIsDcrOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const handleDcrOpen = () => {
		setIsLoading(true);
		setIsDcrOpen(true);
	};

	const handleDcrClose = () => {
		setIsLoading(false);
		setIsDcrOpen(false);
	};

	return (
		<>
			<Box sx={sx.root}>
				<MissingHcpIcon sx={sx.icon} />

				<Box sx={sx.body}>
					<Typography sx={mergeSx(sx.header, customSx?.header)}>
						{entityType === EntityType.Hcp
							? t('Missing a person?')
							: t('Missing an organization?')}
					</Typography>
					<Typography sx={sx.caption}>
						{entityType === EntityType.Hcp
							? t(
									'Tell us who you’re looking for, and we’ll try to add them to our 20m+ records.'
								)
							: t(
									'Tell us what you’re looking for, and we’ll try to add it to our 6m+ records.'
								)}
					</Typography>
					<Button
						sx={sx.button}
						variant='outlined'
						onClick={handleDcrOpen}
						size='small'
						loading={isLoading}
						loadingPosition='start'
					>
						{entityType === EntityType.Hcp
							? t('REQUEST NEW HCP')
							: t('REQUEST NEW HCO')}
					</Button>
				</Box>
			</Box>

			<DataChangeRequest
				entityType={entityType}
				formType={DcrType.Add}
				open={isDcrOpen}
				onClose={handleDcrClose}
				onLoaded={() => setIsLoading(false)}
			/>
		</>
	);
};
